import { oc } from '@orpc/contract';
import { createEstimateInputSchema, estimateDetailSchema } from '../schemas/estimates.schemas.js';
/**
 * Allocates `EST-<year>-NNNN` from the tenant counter and applies the template's published version.
 * It creates an **opportunity, never a stock vehicle** (plan §3.1).
 */
export const createEstimateContract = oc
    .route({
    method: 'POST',
    path: '/estimates',
    tags: ['Estimates'],
    summary: 'Start a new estimate',
})
    .input(createEstimateInputSchema)
    .output(estimateDetailSchema);
//# sourceMappingURL=create-estimate.contract.js.map